import { useTranslation } from "react-i18next";
import { Col, Form, FormInstance, Input, Rate, Row } from "antd";
import { useParams } from "react-router-dom";

const { TextArea } = Input;

interface IProps {
  formRef: React.RefObject<FormInstance<any> | null>;
  onFinish: (values: any) => void;
}

export const RateForm: React.FC<IProps> = ({ formRef, onFinish }) => {
  const { t } = useTranslation();
  const { tenantId } = useParams();
  return (
    <Form
      ref={formRef}
      id="rateForm"
      layout="vertical"
      onFinish={onFinish}
      initialValues={{ rate: 5, tenantId, customerId: 0 }}
    >
      <Form.Item name="customerId" hidden>
        <Input type="number" />
      </Form.Item>
      <Form.Item name="tenantId" hidden>
        <Input type="number" />
      </Form.Item>
      <Row justify="center">
        <Col>
          <Form.Item name="rate">
            <Rate allowHalf allowClear={false} style={{ fontSize: 40 }} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            name="comment"
            label={t("CommentEncouragement")}
            className="comment-highlight"
          >
            <TextArea rows={3} placeholder={t("CommentPlaceholder")} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
